/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "../Header/Header.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Headerlogo from "../../../Assets/Images/logoEliteNew.png";
import { FaChevronDown } from "react-icons/fa";
import { RxHamburgerMenu } from "react-icons/rx";
import { VscAccount } from "react-icons/vsc";
import { MdOutlineEmail } from "react-icons/md";
import { HiOutlineLogout } from "react-icons/hi";
import { GetLoginRole, RemoveUserSession } from "../../../Utils/utils";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../../Context/ProfileContext";
import { CgProfile } from "react-icons/cg";
import { Dropdown } from "react-bootstrap";
import dummyimage from "../../../Assets/Images/dummyimg.png";
import { Modal, Button } from "react-bootstrap";

const Header = ({ showSidebar, setShowSidebar }) => {
  const { profileData } = useProfile();
  const LoginRole = GetLoginRole();
  const [showDropdownHeader, setshowDropdownHeader] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate();

  const handleClick = () => {
    setShowSidebar(!showSidebar);
  };

  const handleLogout = () => {
    RemoveUserSession();
    navigate("/", { replace: true });
  };

  return (
    <>
      {showSidebar ? (
        <>
          <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
            <Container fluid className="header-main-fluid-container">
              <div className="header-logo-div">
                <img src={Headerlogo} alt={dummyimage} />
              </div>

              <div className="RxHamburgerMenu-icon">
                <RxHamburgerMenu onClick={handleClick} />
              </div>

              <Nav className="me-auto"></Nav>

              <Dropdown
                show={showDropdownHeader}
                onToggle={(isOpen) => setshowDropdownHeader(isOpen)}
                className="header-profile-main-dropdown"
              >
                <Dropdown.Toggle
                  className="setheader"
                  id="dropdown-basic"
                  as="div"
                  onClick={() => setshowDropdownHeader(!showDropdownHeader)}
                >
                  <div className="header-profile-dropdown">
                    <p className="header-username">
                      {profileData?.FirstName || "Profile"}
                    </p>

                    {profileData?.UrlLink ? (
                      <img
                        className="image-of-header"
                        src={profileData.UrlLink}
                        alt={dummyimage}
                      />
                    ) : (
                      <CgProfile className="profile-icon-header" />
                    )}

                    <FaChevronDown className="header-dropdown-arrow" />
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="Dropdownset">
                  <NavDropdown.Item
                    href={LoginRole === "Admin" ? "/Adm/Profile" : "/Emp/Profile"}
                    className="navbar-dropdown"
                  >
                    <span>
                      <VscAccount className="navbar-icons" />
                    </span>
                    <span className="text-on-dropdown-header">Profile</span>
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    href="/ForgotPassword"
                    className="navbar-dropdown"
                  >
                    <span>
                      <MdOutlineEmail className="navbar-icons" />
                    </span>
                    <span className="text-on-dropdown-header">
                      Update Password
                    </span>
                  </NavDropdown.Item>

                  <NavDropdown.Divider />

                  <NavDropdown.Item
                    onClick={() => setShowLogoutModal(true)}
                    className="navbar-dropdown"
                  >
                    <span>
                      <HiOutlineLogout className="navbar-icons" />
                    </span>
                    <span className="text-on-dropdown-header">Logout</span>
                  </NavDropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Container>
          </Navbar>
        </>
      ) : (
        <>
          <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
            <Container fluid className="header-main-fluid-container">
              <div className="header-logo-div">
                <img src={Headerlogo} alt="not available" />
              </div>

              <div className="RxHamburgerMenu-icon">
                <RxHamburgerMenu onClick={handleClick} />
              </div>

              <Nav className="me-auto"></Nav>

              <Dropdown
                show={showDropdownHeader}
                onToggle={(isOpen) => setshowDropdownHeader(isOpen)}
                className="header-profile-main-dropdown"
              >
                <Dropdown.Toggle
                  className="setheader"
                  id="dropdown-basic"
                  as="div"
                  onClick={() => setshowDropdownHeader(!showDropdownHeader)}
                >
                  <div className="header-profile-dropdown">
                    <p className="header-username">
                      {profileData?.FirstName || "Profile"}
                    </p>

                    {profileData?.UrlLink ? (
                      <img
                        className="image-of-header"
                        src={profileData.UrlLink}
                        alt={dummyimage}
                      />
                    ) : (
                      <CgProfile className="profile-icon-header" />
                    )}

                    <FaChevronDown className="header-dropdown-arrow" />
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="Dropdownset">
                  <NavDropdown.Item
                    href={LoginRole === "Admin" ? "/Adm/Profile" : "/Emp/Profile"}
                    className="navbar-dropdown"
                  >
                    <span>
                      <VscAccount className="navbar-icons" />
                    </span>
                    <span className="text-on-dropdown-header">Profile</span>
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    href="/ForgotPassword"
                    className="navbar-dropdown"
                  >
                    <span>
                      <MdOutlineEmail className="navbar-icons" />
                    </span>
                    <span className="text-on-dropdown-header">
                      Update Password
                    </span>
                  </NavDropdown.Item>

                  <NavDropdown.Divider />

                  <NavDropdown.Item
                    onClick={() => setShowLogoutModal(true)}
                    className="navbar-dropdown"
                  >
                    <span>
                      <HiOutlineLogout className="navbar-icons" />
                    </span>
                    <span className="text-on-dropdown-header">Logout</span>
                  </NavDropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Container>
          </Navbar>
        </>
      )}

      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <HiOutlineLogout size={40} color="#dc3545" />
          <p className="mt-3">Are you sure you want to logout?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowLogoutModal(false)}
          >
            Cancel
          </Button>

          <Button
            variant="danger"
            onClick={() => {
              setShowLogoutModal(false);
              handleLogout();
            }}
          >
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Header;